import { render, staticRenderFns } from "./VisitPerformedApplication.vue?vue&type=template&id=134aba9f"
import script from "./VisitPerformedApplication.vue?vue&type=script&lang=js"
export * from "./VisitPerformedApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports